const vision = "v1";
import api from "./http";

export default {
    // 防伪
    getAntifake(params) {
        return api.request({
            url: `/label/identity-project/v1/api/amazing/get-anti`,
            method: "get",
            params
        });
    },
    // 异步定位
    getAntiInfo(data) {
        return api.request({
            url: `/pms/v1/anti/from/info`,
            method: "put",
            data
        });
    },
    // 获取微信jssdk授权
    getWeixinJsdk(params) {
        return api.request({
            url: `/marketing/wechat-sdk/${vision}/get-wechat-js-sdk`,
            method: "get",
            params
        });
    },

    // 二维码解码
    qrCodeDecoding(params) {
        return api.request({
            url: `/digit/v1/qr/code/decode-url`,
            method: "get",
            params
        });
    },
    // 解数码
    queryDigit(params) {
        return api.request({
            url: `/digit/v2/digit/query-digit`,
            method: "get",
            params
        });
    },
    // ip解析
    getLocationByIP(params) {
        return api.request({
            url: `/cncop/area/convert-ip`,
            method: "GET",
            permission: "",
            params: Object.assign({}, params, {
                ignoreFlag: true // 不需要token
            })
        });
    },
    /**
     * 坐标转详细地址
     * @param {object} params
     * {
     *  coordinateType:坐标类型,接口默认0。0: bd09ll 百度经纬度坐标;1: bd09mc 百度摩卡托坐标;2: wgs84ll 基础的坐标;3: gcj02ll 国测局加密坐标 国内地图通用坐标类型.
     *  latitude:纬度
     *  longitude:经度
     * }
     * @returns
     */
    getLocationByGPS(params) {
        return api.request({
            url: `/cncop/area/convert-gps`,
            method: "GET",
            params: Object.assign({}, params, {
                ignoreFlag: true // 不需要token
            })
        });
    },
}
